// react
import React, { useEffect, useContext } from 'react';
import ReactTable from "react-table";
import useForm from 'react-hook-form';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// material-ui icons
import Search from "@material-ui/icons/Search";
import LoadingIcon from "@material-ui/icons/Cached";

// material-ui components
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import HeaderProcessoFinal from "beaktClinic/views/Venda/Header/HeaderProcessoFinal"
import Clearfix from 'beaktShared/components/Clearfix/Clearfix';
import { MaskCPF, MaskCel, formateDate } from "beaktShared/helpers/masks";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import GestaoClienteForm from "beaktClinic/views/Clientes/GestaoClienteForm.js";
import Select from 'react-select';
import { ValidSelect } from "beaktShared/helpers/validselect";

// services
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import { setcarrinhoVendaCookie, getcarrinhoVendaCookie } from "beaktClinic/services/carrinhoVenda";
import { UsePostApi, UsePutApi } from "beaktShared/services/crudeApiService";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/identificacaoVenda.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function IdentificacaoVenda({ history }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const session = useContext(SessionContext);
  const { register, errors, setValue, setError, handleSubmit } = useForm({ mode: "onBlur" });
  const [notification, setNotification] = React.useState({
    show: false,
    color: 'info',
    message: ''
  });
  const showNotification = (message, color) => {
    setNotification({
      show: true,
      color: color,
      message: message
    });
    setTimeout(function () {
      setNotification({ show: false });
    }, 6000);
  };

  const [loadCarrinho, setloadCarrinho] = React.useState(getcarrinhoVendaCookie());

  const [atendente, setatendente] = React.useState();

  const [showAvaliacaoPendente, setshowAvaliacaoPendente] = React.useState(false);
  const [showInformarCliente, setshowInformarCliente] = React.useState(false);
  const [avaliacaoSelecionadaId, setavaliacaoSelecionadaId] = React.useState(0);

  const [novo_cliente, set_novo_cliente] = React.useState(false);

  useEffect(() => {

    if (loadCarrinho.itens.length === 0)
      history.push("/adminclinic/venda");

    verifyIndent(loadCarrinho);

    loadListAtendentes();

    localStorage.setItem('novo_cliente', false);

  }, [loadCarrinho]);

  const [avaliacao_obrigatoria, setavaliacao_obrigatoria] = React.useState(false);

  const verifyIndent = (carrinho) => {

    verifyAvaliacaoObrigatoria().then(result => {
      setavaliacao_obrigatoria(result);
      let resultAV = verifyshowAvaliacaoPendente(carrinho);
      if (!resultAV)
        verifyClient(carrinho);
    });
  }

  const verifyClient = () => {
    if (loadCarrinho.clienteId === 0)
      return false;

    setloadingValidateCPF(true);
    const endPoint = "clientes/" + loadCarrinho.clienteId;
    UseGetApiSimple(endPoint).then(result => {
      if (result.status !== 200) {
        setloadingValidateCPF(false);
        setloadingValidateEmail(false);

        return false;
      }
      setValue("id", result.data.clienteId);
      setValue("cpf", result.data.cpf);
      setValue("nome", result.data.nome);
      setValue("celular", result.data.celular);
      setValue("email", result.data.email);
      setValue('usuarioId', result.data.usuarioId);
      setloadingValidateCPF(false);
      setloadingValidateEmail(false);
      setdisabledNOME(true);

      if (result.data.cpf != "" && result.data.cpf != null) {
        setdisabledCPF(true);
      }
      else {
        setdisabledCPF(false);
      }
      if (result.data.email != "" && result.data.email != null) {
        setdisabledEMAIL(true);
      }
      else {
        setdisabledEMAIL(false);
      }

      return true;
    });

  }
  const verifyAvaliacaoObrigatoria = async () => {
    const promise = new Promise((resolve, reject) => {

      let endPointEstabelecimento = "estabelecimentos/" + session.estabelecimentoId;

      UseGetApiSimple(endPointEstabelecimento).then(async result => {
        if (result.status !== 200) {
          showNotification(result.message.message, 'danger');
          resolve(false);
        }

        resolve(result.data.avaliacaoObrigatoriaPacote);
      });
    });
    return promise;
  }

  const verifyshowAvaliacaoPendente = (carrinho, avaliacaoObrigatoria) => {
    setshowAvaliacaoPendente(false);
    setshowInformarCliente(false);
    //Verifica se existe algum item do tipo pacote no carrinho
    let listFiltered = carrinho.itens.filter(obj => {
      return (obj.tipoItem === 2);
    });

    if (listFiltered.length > 0) {
      setshowAvaliacaoPendente(true);
      setshowInformarCliente(false);
      return true;
    }
    else {
      setshowAvaliacaoPendente(false);
      setshowInformarCliente(true);
    }
    return false;
  }

  const intialValues = {
    id: 0,
    cpf: '',
    nome: '',
    ativo: true,
    email: '',
    celular: '',
    usuarioId: 0
  }

  const [loadingValidateCPF, setloadingValidateCPF] = React.useState(false);
  const [loadingValidateEmail, setloadingValidateEmail] = React.useState(false);
  const [disabledCPF, setdisabledCPF] = React.useState(false);
  const [disabledNOME, setdisabledNOME] = React.useState(false);
  const [disabledEMAIL, setdisabledEMAIL] = React.useState(false);

  const [clienteId, setclienteId] = React.useState(0);

  const handleCPFChange = e => {

    let cpf = e.target.value;
    if (cpf === "")
      return;

    const endPoint = "clientes/clientebycpfvenda/" + cpf + "/" + session.estabelecimentoId;
    UseGetApiSimple(endPoint, 0).then(result => {
      // retorno = 500 é exception especifica para cliente que está na LISTA NEGRA!
      if (result.status === 500) {
        showNotification(result.message, 'danger')
        setloadingValidateCPF(false);
        return false;
      }

      if (result.status !== 200) {
        if (clienteId == 0) {

          clearDadosCliente("cpf");

          //informa que tem que preencher primeiro o atendente 
          if (atendente == null) {
            setError("atendente", "Selecione o atendente");
            setloadingValidateCPF(false);
            return;
          }

          //significa que é um novo cliente e precisa abrir o form do cliente para cadastrar e preencher seus dados
          setshowInformarCliente(false);
          setshowCadastroCompleto(true);
          setitemDADOS({ cpf: cpf });

          setdisabledNOME(false);
          setdisabledCPF(false);
          setdisabledEMAIL(false);
        }
        setloadingValidateCPF(false);

        return false;
      }
      setloadingValidateCPF(false);

      setdisabledNOME(true);
      if (result.data.cpf != "" && result.data.cpf != null) {
        setdisabledCPF(true);
      }
      else {
        setdisabledCPF(false);
      }
      if (result.data.email != "" && result.data.email != null) {
        setdisabledEMAIL(true);
      }
      else {
        setdisabledEMAIL(false);
      }
      setclienteId(result.data.clienteId);

      //Verifica se existe algum item do tipo serviço no carrinho, se sim abrir modal de ados do cliente para completar todo o cadastro
      VerificaItensVenda(result.data);
    });
  }

  const VerificaItensVenda = (data) => {
    let listFiltered = loadCarrinho.itens.filter(obj => {
      return (obj.tipoItem === 1 || obj.tipoItem === 2);
    });

    if (listFiltered.length > 0) {

      setitemDADOS({
        cpf: data.cpf,
        clienteId: data.clienteId,
        nome: data.nome,
        celular: data.celular,
        email: data.email,
        usuarioId: data.usuarioId,
        rg: data.rg,
        dataNascimento: data.dataNascimento,
        sexo: data.sexo,
        rua: data.rua,
        numero: data.numero,
        complemento: data.complemento,
        bairro: data.bairro,
        cidade: data.cidade,
        estado: data.estado,
        cep: data.cep
      });

      //seta as contantes para abrir o form do cliente para revisar seus dados, para nao sair nada faltando nos dados do cliente no contrato
      setshowInformarCliente(false);
      setshowCadastroCompleto(true);

      return true;
    }
    else {
      setValue("id", data.clienteId);
      setValue("nome", data.nome);
      setValue("cpf", data.cpf);
      setValue("celular", data.celular);
      setValue("email", data.email);
      setValue('usuarioId', data.usuarioId);
    }

  }

  const handleEmailChange = e => {

    let email = e.target.value;
    if (email === "")
      return;

    const endPoint = "clientes/clientebyemailvenda/" + email + "/" + session.estabelecimentoId;
    UseGetApiSimple(endPoint, 0).then(result => {
      // retorno = 500 é exception especifica para cliente que está na LISTA NEGRA!
      if (result.status === 500) {
        showNotification(result.message, 'danger')
        setloadingValidateEmail(false);
        return false;
      }

      if (result.status !== 200) {
        // pode ser que ja exista um clienteId carregado na tela, e esse cliente não tenha um email,   
        if (clienteId == 0) {

          clearDadosCliente("email");

          //informa que tem que preencher primeiro o atendente 
          if (atendente == null) {
            setError("atendente", "Selecione o atendente");
            setloadingValidateEmail(false);
            return;
          }

          //significa que é um novo cliente e precisa abrir o form do cliente para cadastrar e preencher seus dados
          setshowInformarCliente(false);
          setshowCadastroCompleto(true);
          setitemDADOS({ email: email });

          setdisabledNOME(false);
          setdisabledEMAIL(false);
          setdisabledCPF(false);
        }
        return false;
      }

      setdisabledNOME(true);
      if (result.data.cpf != "" && result.data.cpf != null) {
        setdisabledCPF(true);
      }
      else {
        setdisabledCPF(false);
      }
      if (result.data.email != "" && result.data.email != null) {
        setdisabledEMAIL(true);
      }
      else {
        setdisabledEMAIL(false);
      }
      setclienteId(result.data.clienteId);
      VerificaItensVenda(result.data);
    });
  }

  const clearDadosCliente = (clear) => {
    setValue("id", 0);
    setValue("nome", "");
    setValue("celular", "");
    setValue('usuarioId', 0);
    localStorage.setItem('novo_cliente', true);
    // se o clearDadosCliente foi chamado pelo handle cpf limpa o outro campo de busca que é email, e mantém o cpf
    // se o clearDadosCliente foi chamado pelo handle email limpa o outro campo de busca que é cpf e mantém o email
    if (clear == "cpf")
      setValue("email", "");

    if (clear == "email")
      setValue("cpf", "");
  }

  const [showCadastroCompleto, setshowCadastroCompleto] = React.useState(false);
  const [itemDADOS, setitemDADOS] = React.useState({});
  const handleAdd = item => {

    //informa que tem que preencher primeiro o atendente, pra depois deixar ir pra próxima tela
    if (atendente == null) {
      setError("atendente", "Selecione o atendente");
      return;
    }

    let newLC = {
      ...loadCarrinho,
      avaliacaoId: avaliacaoSelecionadaId,
      clienteId: item.clienteId,
      usuarioAtendenteId: atendente
    }
    setcarrinhoVendaCookie(newLC);
    setLoadingForm(false);
    history.push("/adminclinic/pagamentovenda");
  }

  const reinicializarClick = () => {

    setValue('id', 0);
    setValue('cpf', '');
    setValue('nome', '');
    setValue('email', '');
    setValue('celular', '');

    setclienteId(0);
    setdisabledNOME(false);
    setdisabledCPF(false);
    setdisabledEMAIL(false);

  }

  const [LoadingForm, setLoadingForm] = React.useState(false);
  const onSubmit = (data, e) => {

    setTimeout(() => {

      _onSubmit(data, e);

    }, 500);

  }

  const _onSubmit = (data, e) => {
    // criado para corrigir ticket 210069, onde o cliente altera o cpf e ja clica direto em ENVIAR
    if (localStorage.getItem('novo_cliente') == 'true') {
      return;
    }

    e.preventDefault();

    //informa que tem que preencher primeiro o atendente, pra depois deixar ir pra próxima tela
    if (atendente == null) {
      setError("atendente", "Selecione o atendente");
      return;
    }

    setLoadingForm(true);

    var cliente = {
      clienteId: parseInt(data.id),
      nome: data.nome,
      ativo: true,
      cpf: data.cpf,
      email: data.email,
      celular: data.celular,
      usuarioCadastroId: session.id,
      usuarioId: parseInt(data.usuarioId)
    }
    var estabelecimentoClientes = [
      {
        clienteId: cliente.clienteId,
        estabelecimentoId: session.estabelecimentoId
      }
    ];
    var newitem = { ...cliente, estabelecimentoClientes };

    var verifyInsert = false;
    if (newitem.clienteId === 0)
      verifyInsert = true;

    let endPoint = 'clientes/';

    if (!verifyInsert) {
      setLoadingForm(true);
      verifyClientVendaEmProcessamento(newitem.clienteId, function (result) {
        if (result) {
          setLoadingForm(false);
          return;
        }
        endPoint = endPoint + "alterfromvenda/";
        UsePutApi(endPoint, newitem.clienteId, newitem).then(result => {
          if (result.status !== 200) {
            showNotification(result.message, 'danger');
            setLoadingForm(false);
            return false;
          }

          let newLC = {
            ...loadCarrinho,
            avaliacaoId: avaliacaoSelecionadaId,
            clienteId: newitem.clienteId,
            usuarioAtendenteId: atendente
          }
          setcarrinhoVendaCookie(newLC);
          setLoadingForm(false);
          showNotification(result.message, 'success');
          history.push("/adminclinic/pagamentovenda");
          return true;
        });
      })
    }
    else {
      setLoadingForm(true);
      UsePostApi(endPoint, newitem).then(result => {
        if (result.status !== 201) {
          showNotification(result.message.message, 'danger');
          setLoadingForm(false);
          return false;
        }

        let newLC = {
          ...loadCarrinho,
          avaliacaoId: avaliacaoSelecionadaId,
          clienteId: result.data.clienteId,
          usuarioAtendenteId: atendente
        }
        setcarrinhoVendaCookie(newLC);
        setLoadingForm(false);
        showNotification(result.message, 'success');
        history.push("/adminclinic/pagamentovenda");
        return true;
      });
    }
  }

  const verifyClientVendaEmProcessamento = (clienteId, callback) => {
    if (clienteId === 0) {
      callback(false);
    }

    let endPoint = "clientes/ExisteVendaEmProcessamento/" + clienteId;
    UseGetApiSimple(endPoint).then(result => {
      if (result.status !== 200) {
        showNotification("Não foi possível verificar se existem vendas para esse cliente!", 'danger');
        callback(false);
      }
      else {
        if (result.data == true) {
          showNotification("Já existe uma venda para este CPF aguardando retorno da Administradora do Cartão de Crédito. Verifique na tela Vendas Aguardando Autorização!", 'warning');
        }
        callback(result.data);
      }
    });

  }

  const handleSearchChange = event => {

    //informa que tem que preencher primeiro o atendente, pra depois liberar pra selecionar avaliação
    if (atendente == null) {
      setError("atendente", "Selecione o atendente");
      return;
    }

    if (event.target.value.length >= 3)
      loadAvaliacoesPendente(event.target.value);
  }

  const [loadingAvaliacoes, setloadingAvaliacoes] = React.useState(false);
  const [errorAvaliacoes, seterrorAvaliacoes] = React.useState(false);
  const [list, setlist] = React.useState([]);
  const loadAvaliacoesPendente = (nomeCpf) => {
    setloadingAvaliacoes(true);
    seterrorAvaliacoes("");
    const endPoint = "avaliacoes/byestabelecimentofiltered/" + session.estabelecimentoId + "/" + nomeCpf
    UseGetApiSimple(endPoint, 0).then(result => {
      if (result.status !== 200) {
        seterrorAvaliacoes(result.message);
        setloadingAvaliacoes(false);
      }
      setlist(result.data);
      setloadingAvaliacoes(false);
      return true;
    });

  }

  const vincularAvaliacaoVenda = (avaliacao) => {

    verifyClientVendaEmProcessamento(avaliacao.clienteId, function (result) {
      if (result) {
        setLoadingForm(false);
        return;
      }
      let newLC = {
        ...loadCarrinho,
        avaliacaoId: avaliacao.avaliacaoId,
        clienteId: avaliacao.clienteId
      }

      setcarrinhoVendaCookie(newLC);
      setitemDADOS(avaliacao.cliente);
      setdisabledNOME(true);
      setdisabledCPF(true);
      setdisabledEMAIL(true);
      setshowCadastroCompleto(true);
      setshowAvaliacaoPendente(false);
      setavaliacaoSelecionadaId(avaliacao.avaliacaoId);

      //history.push("/adminclinic/pagamentovenda");
    })

  }

  const [isLoadingAtendentes, setisLoadingAtendentes] = React.useState(false);
  const [listSelectAtendentes, setlistSelectAtendentes] = React.useState([]);
  const loadListAtendentes = () => {
    setisLoadingAtendentes(true);
    UseGetApiSimple("usuarios/atendentebyestabelecimento/" + session.estabelecimentoId, 0).then(result => {
      if (result.status !== 200) {
        setisLoadingAtendentes(false);
        showNotification(result.message, 'danger');
        return false;
      }
      setisLoadingAtendentes(false);
      setlistSelectAtendentes(result.data);

      return true;
    });
  }

  const handleAtendenteChange = (value) => {
    setatendente(value);
    errors.atendente = false;
  }

  const handlePularAvaliacao = () => {
    setshowAvaliacaoPendente(false);
    setshowInformarCliente(true);
  }


  const columnsProp = [{
    Header: t('label.client_name'),
    accessor: "cliente.nome",
    filterable: false
  },
  {
    Header: t('label.date') + " " + t('sidebar.avaliation'),
    accessor: "dataCadastro",
    Cell: (props) => {
      let custom_date = formateDate(props.value);
      return <span>{custom_date}</span>
    },
    filterable: false
  },
  {
    Header: t('label.cell_phone'),
    accessor: "cliente.celular",
    filterable: false
  }]
  const columnsAcao = [
    {
      Header: "",
      Cell: row => (
        <div style={{ textAlign: 'right' }}>
          <Button color="transparent" style={{ border: '2px solid #562682', color: '#562682' }}
            onClick={() => vincularAvaliacaoVenda(row.original)}>
            {t('label.select')}
          </Button>
        </div>
      ),
      sortable: false,
      filterable: false
    }
  ];
  const columns = [...columnsProp, ...columnsAcao]


  return (
    <div className="maxContent">

      <HeaderProcessoFinal etapa={1}></HeaderProcessoFinal>

      <GridContainer>

        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardBody>

              <h3>{t('label.attendant')}</h3>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <Select
                    classNamePrefix="select"
                    isLoading={isLoadingAtendentes}
                    styles={ValidSelect(errors.atendente ? true : false)}
                    isSearchable={true}
                    name="atendente"
                    placeholder="Selecione"
                    options={listSelectAtendentes}
                    getOptionLabel={({ nome }) => nome}
                    getOptionValue={({ usuarioId }) => usuarioId}
                    value={listSelectAtendentes.filter(f => f.usuarioId == atendente)}
                    onChange={(value) => handleAtendenteChange(value.usuarioId !== null ? value.usuarioId : "")}
                    ref={() => register(
                      { name: "atendente" },
                      { required: false })
                    }
                  />
                  <FormHelperText className={classes.labelRootError}>
                    {errors.atendente && <span className="obg">{t('label.required')}</span>}
                  </FormHelperText>
                </GridItem>
              </GridContainer>

              <br />

              {showInformarCliente &&
                <div>
                  <h3>{t('sale.customer_data')}</h3>
                  <div style={{ maxWidth: '700px', margin: '0 auto' }}>

                    <form onSubmit={handleSubmit(onSubmit)}>
                      <input className="hidden" defaultValue={intialValues.id} name="id" ref={register} />
                      <input className="hidden" defaultValue={intialValues.usuarioId} name="usuarioId" ref={register} />

                      <GridContainer>
                        <GridItem xs={12} sm={3} md={3}>
                          <div className={classes.labelIdent}>
                            {t('label.cpf')} *
                          </div>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            defaultValue=""
                            name="cpf"
                            disabled={disabledCPF}
                            inputRef={register({ required: true })}
                            error={errors.cpf ? true : false}
                            onBlur={handleCPFChange}
                            InputProps={{
                              inputComponent: MaskCPF,
                              endAdornment: (
                                <InputAdornment position="end">
                                  {loadingValidateCPF && <LoadingIcon className="rotate" />}
                                </InputAdornment>
                              ),
                            }}
                          />
                          <FormHelperText >
                            {errors.cpf && <span className="obg">{t('label.required')}</span>}
                          </FormHelperText>
                        </GridItem>
                      </GridContainer>

                      <GridContainer>
                        <GridItem xs={12} sm={3} md={3}>
                          <div className={classes.labelIdent}>
                            {t('label.name')} *
                          </div>
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            defaultValue=""
                            name="nome"
                            disabled={disabledNOME}
                            inputRef={register({ required: true })}
                            error={errors.nome ? true : false}
                          />
                          <FormHelperText>
                            {errors.nome && <span className="obg">{t('label.required')}</span>}
                          </FormHelperText>
                        </GridItem>
                      </GridContainer>

                      <GridContainer>
                        <GridItem xs={12} sm={3} md={3}>
                          <div className={classes.labelIdent}>
                            {t('label.email')} *
                          </div>
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <TextField
                            fullWidth
                            error={errors.email ? true : false}
                            variant="outlined"
                            onBlur={handleEmailChange}
                            inputRef={register({
                              required: true,
                              pattern: {
                                value: /^\S+@\S+$/i,
                                message: t('label.invalid_email')
                              },
                              maxLength: {
                                value: 50,
                                message: t('label.enter_a_maximum_of_50_characters')
                              }
                            })}
                            name="email"
                            disabled={disabledEMAIL}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  {loadingValidateEmail && <LoadingIcon className="rotate" />}
                                </InputAdornment>
                              ),
                            }}
                          />
                          <FormHelperText>
                            {errors.email && <span className="obg">
                              {errors.email.message === "" ? t('label.required') : errors.email.message}
                            </span>}
                          </FormHelperText>
                        </GridItem>
                      </GridContainer>

                      <GridContainer>
                        <GridItem xs={12} sm={3} md={3}>
                          <div className={classes.labelIdent}>
                            {t('label.cell_phone')} *
                          </div>
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            defaultValue=""
                            name="celular"
                            inputRef={register({ required: true })}
                            error={errors.celular ? true : false}
                            InputProps={{ inputComponent: MaskCel }}
                          />
                          <FormHelperText>
                            {errors.celular && <span className="obg">{t('label.required')}</span>}
                          </FormHelperText>
                        </GridItem>
                      </GridContainer>

                      <GridContainer>
                        <GridItem xs={12} sm={3} md={3}>
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <Button type="submit" color="primary" >
                            {t('button.send')}
                          </Button>
                          {LoadingForm && <CircularProgress size="20" />}
                        </GridItem>
                      </GridContainer>
                      <GridContainer>
                        <div>
                          <Button className="no-print" color="warning" onClick={() => reinicializarClick()}>
                            {t('button.restart')}
                          </Button>
                        </div>
                      </GridContainer>
                      <Clearfix />
                    </form>
                  </div>

                </div>
              }

              {showAvaliacaoPendente &&
                <div>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={7}>
                      <p>
                        {t('sale.text_customer_avaliation1')}
                        {t('sale.text_customer_avaliation2')} </p>
                      <h3>{t('sidebar.pending_avaliation')}</h3>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5} className="text-right">
                      <Link to="/adminclinic/avaliacao" >
                        <Button color="info" >
                          {t('sidebar.new_avaliation')}
                        </Button>
                      </Link>
                      {!avaliacao_obrigatoria && // só exibe o botão se a avaliação NÃO for obrigatório na venda                        
                        <Button color="primary" onClick={() => handlePularAvaliacao()} >
                          {t('button.advance')}
                        </Button>
                      }
                    </GridItem>
                  </GridContainer>
                  <Clearfix />
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <TextField
                        fullWidth
                        error={errors.pesquisar ? true : false}
                        placeholder={t('information_message.type_code_or_name_to_search') + "..."}
                        variant="outlined"
                        inputRef={register({
                          maxLength: {
                            value: 50,
                            message: t('label.enter_a_maximum_of_50_characters')
                          }
                        })}
                        name="pesquisar"
                        InputLabelProps={{ shrink: true }}
                        onChange={handleSearchChange}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <div style={{ clear: 'both' }}></div>
                  <br />

                  {errorAvaliacoes !== "" && <div>{errorAvaliacoes}</div>}
                  <ReactTable
                    loading={loadingAvaliacoes}
                    data={list}
                    columns={columns}
                    filterable
                    defaultFilterMethod={noCaseSensitive}
                    defaultPageSize={10}
                    minRows={5}
                    showPaginationBottom={true}
                    className="-striped -highlight"
                    previousText={t('button.previous')}
                    nextText={t('button.next')}
                    loadingText={t('label.loading') + "..."}
                    noDataText={t('information_message.no_records_found') + "!"}
                    pageText={t('label.page')}
                    ofText={t('label.of')}
                    rowsText={t('label.rows')}
                  />

                </div>
              }

              {showCadastroCompleto &&
                <GestaoClienteForm addItem={handleAdd} item={itemDADOS} handleView={null} estabelecimentoId={session.estabelecimentoId} disabledNOME={disabledNOME} disabledCPF={disabledCPF} disabledEMAIL={disabledEMAIL} ></GestaoClienteForm>
              }

            </CardBody>
          </Card>
        </GridItem>


      </GridContainer>


      <Snackbar
        place="tr"
        color={notification.color}
        message={notification.message}
        open={notification.show}
        closeNotification={() => setNotification({ show: false })}
        close
      />
    </div>
  );
}